module.exports = __webpack_public_path__ + "static/media/facebook-link.958b8d1e.svg";